document.addEventListener("DOMContentLoaded", function () {
    var onSwiperReady = window.mobidevOnSwiperReady || function (cb) {
        if (typeof Swiper !== "undefined") {
            cb();
        }
    };
    onSwiperReady(function () {
        document.querySelectorAll(".last-insights__slider").forEach(function (slider) {
            const container = slider.closest(".last-insights");

            if (!container) {

                return;
            }

            const nextButton = container.querySelector(".last-insights__next");
            const prevButton = container.querySelector(".last-insights__prev");
            const pagination = container.querySelector(".last-insights__pagination");

            new Swiper(slider, {
                slidesPerView: 1.065,
                loop: true,
                spaceBetween: 16,
                speed: 800,
                autoHeight: true,
                navigation: {
                    nextEl: nextButton || null,
                    prevEl: prevButton || null,
                },
                pagination: {
                    el: pagination || null,
                    clickable: !!pagination,
                },
                breakpoints: {
                    767: {
                        spaceBetween: 24,
                        slidesPerView: 1.07,
                    },
                    1200: {
                        spaceBetween: 240,
                        slidesPerView: 1,
                    },
                },
            });
        });
    });
});
